import { Injectable } from "@angular/core";
import { CiudadDTO, PaisDTO, RegionDTO } from "@DTOS";
import { PaisesServiceBackend } from "@serviceBackends";

@Injectable({
    providedIn: "root"
})
export class PaisesService {
    private regiones = new Map<number, RegionDTO[]>();
    private ciudades = new Map<number, CiudadDTO[]>();

    constructor(private paisesServiceBackend: PaisesServiceBackend) { }

    public async obtenerPaises(): Promise<PaisDTO[]> {
        return await this.paisesServiceBackend.getPaises();
    }

    public async obtenerRegiones(pais: PaisDTO): Promise<RegionDTO[]> {
        if (!this.regiones.has(pais.id)) {
            const regiones = await this.paisesServiceBackend.getRegiones(pais);

            this.regiones.set(pais.id, regiones);
        }

        return this.regiones.get(pais.id) ?? [];
    }

    public async obtenerCiudades(pais: PaisDTO, region: RegionDTO): Promise<CiudadDTO[]> {
        if (!this.ciudades.has(region.id)) {
            const ciudades = await this.paisesServiceBackend.getCiudades(pais, region);

            this.ciudades.set(region.id, ciudades);
        }

        return this.ciudades.get(region.id) ?? [];
    }
}
